import { Button, Card, Col, DatePicker, Form, Input, InputNumber, Row, Select } from "antd";
import React from "react";
import { FaDollarSign } from "react-icons/fa";
import PageHeading from "../../../../../components/common/PageHeading";

const NewCommonCharge = () => {
  const onChange = (value) => {
    console.log(`selected ${value}`);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };
  return (
    <div>
      <PageHeading heading="New Common Charge" />
      <Form name="basic" autoComplete="off" layout="vertical">
        <Card>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Property" name="Property" required>
                <Select
                  showSearch
                  allowClear
                  placeholder="Start typing to search"
                  optionFilterProp="children"
                  onChange={onChange}
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value:
                        "GF3, Block 58, Seaview Apartments, DHA Phase 5 P/O Sost Nazimabad, Gojal Hunza, Hunza Nagar Karachi,  75500",
                      label:
                        "GF3, Block 58, Seaview Apartments, DHA Phase 5 P/O Sost Nazimabad, Gojal Hunza, Hunza Nagar Karachi,  75500",
                    },
                    {
                      value:
                        "9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
                      label:
                        "9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
                    },
                    {
                      value:
                        "9693 Oak Tree Terrace - 9693 Oak Tree Terrace  Midwest City, OK 73130",
                      label:
                        "9693 Oak Tree Terrace - 9693 Oak Tree Terrace  Midwest City, OK 73130",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="Amount" required>
                      <InputNumber
                        placeholder="Amount"
                        addonBefore={<FaDollarSign size={12} />}
                      />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="Charge Date" required>
                      <DatePicker format="MM-DD-YYYY" style={{width:'100%'}}/>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="Posting Date">
                      <DatePicker format="MM-DD-YYYY" style={{width:'100%'}}/>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
            <Form.Item label="GL Account" required>
            <Select
                  showSearch
                  allowClear
                  placeholder="Start typing to search"
                  optionFilterProp="children"
                  onChange={onChange}
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      label: 'Income',
                      options: [
                        {
                          label: 'Delinquency',
                          value: 'Delinquency',
                        },
                        {
                          label: 'Gross Potential Rent',
                          value: 'Gross Potential Rent',
                        },
                        {
                          label: 'Insurance Services',
                          value: 'Insurance Services',
                        },
                      ],
                    },
                    
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
            <Form.Item label="Description">
                     <Input placeholder="e.g. November Rent"/>
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <br />
        <Row gutter={16}>
          <Col>
            <Button type="primary">Save & Add Another</Button>
          </Col>
          <Col>
            <Button>Save</Button>
          </Col>
          <Col>
            <Button>Cancel</Button>
          </Col>
        </Row>
      </Form>
      <div className="RightSidebar">
       </div>
    </div>
  );
};

export default NewCommonCharge;
